import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {AlertService} from '../services/alert.service';
import {Router} from '@angular/router';
import {ErrorHandlerService} from '../services/error-handler.service';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ResponseErrorModel} from '../models/response-error-model';
import {ConfigurationService} from '../services/configuration.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  constructor(
    private alertService: AlertService,
    private router: Router,
    private errorHandler: ErrorHandlerService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (ConfigurationService.isUseFakeApi) {
      let response = new HttpResponse();
      response = response.clone({status: 200});
      return of(response);
    }
    if (!window.navigator.onLine) {
      return throwError(
        // in place of clone:
        new HttpErrorResponse({
          error: this.CustomNotOnlineResponse(),
        }),
      );
    }
    return next.handle(req)
      .pipe(map(event => {
        if (event instanceof HttpResponse) {
          if (event.body && event.body.message && event.status >= 300) {
            event = event.clone({body: this.resolveError(event.body)});
          }
        }
        return event;
      }))
      .pipe(catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(error);
      }));
  }

  private resolveError(body: any) {
    return {
      response: null,
      error: this.CustomMessageResponse(body.message)
    };
  }


  CustomMessageResponse(msg: string): ResponseErrorModel {
    const data: ResponseErrorModel = new ResponseErrorModel();
    data.errors = [];
    data.message = msg;
    return data;
  }

  CustomNotOnlineResponse(): ResponseErrorModel {
    const data: ResponseErrorModel = new ResponseErrorModel();
    data.message = 'Token Expired';
    return data;
  }

}
